export const accountEntityRelationships = ['ASSOCIATE', 'OWNER'] as const;

export const accountStatuses = ['ACTIVE', 'DEACTIVATED', 'PENDING'] as const;

export const accountTypes = ['DESIGNATED', 'LOCAL'] as const;

export const activityTypes = [
	'ACCOUNT_CREATED',
	'ACCOUNT_UPDATED',
	'ACT_CREATED',
	'ACT_UPDATED',
	'BENEFIT_CREATED',
	'BENEFIT_UPDATED',
	'CASH_IN_METHOD_ACTIVATED',
	'CASH_IN_METHOD_CREATED',
	'CASH_IN_METHOD_DEACTIVATED',
	'CASH_IN_METHOD_DELETED',
	'CASH_IN_METHOD_UPDATED',
	'CATEGORY_ACTIVATED',
	'CATEGORY_CREATED',
	'CATEGORY_DEACTIVATED',
	'CATEGORY_UPDATED',
	'COMMENT_CREATED',
	'COMPONENT_ACTIVATED',
	'COMPONENT_CREATED',
	'COMPONENT_DEACTIVATED',
	'COMPONENT_UPDATED',
	'CONTRACT_CREATED',
	'CONTRACT_UPDATED',
	'DOCUMENT_CREATED',
	'DOCUMENT_TYPE_CREATED',
	'DOCUMENT_TYPE_UPDATED',
	'DOCUMENT_UPDATED',
	'ENTITY_CREATED',
	'ENTITY_UPDATED',
	'ENTITY_WALLET_ACTIVATED',
	'ENTITY_WALLET_DEACTIVATED',
	'EXPENSE_TYPE_ACTIVATED',
	'EXPENSE_TYPE_CREATED',
	'EXPENSE_TYPE_DEACTIVATED',
	'EXPENSE_TYPE_UPDATED',
	'FORM_CREATED',
	'FORM_UPDATED',
	'IFR_CREATED',
	'IFR_FINALIZED',
	'IFR_PLAN_CREATED',
	'IFR_PLAN_UPDATED',
	'IFR_PLAN_VERSION_APPROVED',
	'IFR_PLAN_VERSION_CREATED',
	'IFR_PLAN_VERSION_FINALIZED',
	'IFR_PLAN_VERSION_REJECTED',
	'IFR_PLAN_VERSION_UPDATED',
	'IFR_UPDATED',
	'ILAP',
	'LOAN_CREATED',
	'LOAN_ENABLED',
	'LOAN_UPDATED',
	'PAYMENT_CREATED',
	'PROGRAM_CREATED',
	'PROGRAM_UPDATED',
	'PROJECT_CREATED',
	'PROJECT_UPDATED',
	'RECONCILIATION_ITEM_ACTIVATED',
	'RECONCILIATION_ITEM_CREATED',
	'RECONCILIATION_ITEM_DEACTIVATED',
	'RECONCILIATION_ITEM_UPDATED',
	'TRANSACTION_CONFIRMED',
	'TRANSACTION_CREATED',
	'TRANSACTION_REVERTED',
	'TRANSACTION_UPDATED',
	'USER_ADDED',
	'USER_CREATED',
	'USER_REMOVED',
	'USER_UPDATED',
] as const;

export const actStatuses = ['COMPLETED', 'READY', 'PENDING', 'STARTED'] as const;

export const blkTransactionStatuses = ['DONE', 'FAILED', 'STARTED'] as const;

export const categoryStatuses = ['ACTIVE', 'DEACTIVATED'] as const;

export const cashInMethodStatuses = ['ACTIVE', 'DEACTIVATED'] as const;

export const componentStatuses = ['ACTIVE', 'DEACTIVATED'] as const;

export const reconciliationItemStatuses = ['ACTIVE', 'DEACTIVATED'] as const;

export const countryCodes = [
	'AD',
	'AE',
	'AF',
	'AG',
	'AI',
	'AL',
	'AM',
	'AO',
	'AQ',
	'AR',
	'AS',
	'AT',
	'AU',
	'AW',
	'AX',
	'AZ',
	'BA',
	'BB',
	'BD',
	'BE',
	'BF',
	'BG',
	'BH',
	'BI',
	'BJ',
	'BL',
	'BM',
	'BN',
	'BO',
	'BQ',
	'BR',
	'BS',
	'BT',
	'BV',
	'BW',
	'BY',
	'BZ',
	'CA',
	'CC',
	'CD',
	'CF',
	'CG',
	'CH',
	'CI',
	'CK',
	'CL',
	'CM',
	'CN',
	'CO',
	'CR',
	'CU',
	'CV',
	'CW',
	'CX',
	'CY',
	'CZ',
	'DE',
	'DJ',
	'DK',
	'DM',
	'DO',
	'DZ',
	'EC',
	'EE',
	'EG',
	'EH',
	'ER',
	'ES',
	'ET',
	'FI',
	'FJ',
	'FK',
	'FM',
	'FO',
	'FR',
	'GA',
	'GB',
	'GD',
	'GE',
	'GF',
	'GG',
	'GH',
	'GI',
	'GL',
	'GM',
	'GN',
	'GP',
	'GQ',
	'GR',
	'GS',
	'GT',
	'GU',
	'GW',
	'GY',
	'GZ',
	'HK',
	'HM',
	'HN',
	'HR',
	'HT',
	'HU',
	'ID',
	'IE',
	'IL',
	'IM',
	'IN',
	'IO',
	'IQ',
	'IR',
	'IS',
	'IT',
	'JE',
	'JM',
	'JO',
	'JP',
	'KE',
	'KG',
	'KH',
	'KI',
	'KM',
	'KN',
	'KP',
	'KR',
	'KW',
	'KY',
	'KZ',
	'LA',
	'LB',
	'LC',
	'LI',
	'LK',
	'LR',
	'LS',
	'LT',
	'LU',
	'LV',
	'LY',
	'MA',
	'MC',
	'MD',
	'ME',
	'MF',
	'MG',
	'MH',
	'MK',
	'ML',
	'MM',
	'MN',
	'MO',
	'MP',
	'MQ',
	'MR',
	'MS',
	'MT',
	'MU',
	'MV',
	'MW',
	'MX',
	'MY',
	'MZ',
	'NA',
	'NC',
	'NE',
	'NF',
	'NG',
	'NI',
	'NL',
	'NO',
	'NP',
	'NR',
	'NU',
	'NZ',
	'OM',
	'PA',
	'PE',
	'PF',
	'PG',
	'PH',
	'PK',
	'PL',
	'PM',
	'PN',
	'PR',
	'PS',
	'PT',
	'PW',
	'PY',
	'QA',
	'RE',
	'RO',
	'RS',
	'RU',
	'RW',
	'SA',
	'SB',
	'SC',
	'SD',
	'SE',
	'SG',
	'SH',
	'SI',
	'SJ',
	'SK',
	'SL',
	'SM',
	'SN',
	'SO',
	'SR',
	'SS',
	'ST',
	'SV',
	'SX',
	'SY',
	'SZ',
	'TC',
	'TD',
	'TF',
	'TG',
	'TH',
	'TJ',
	'TK',
	'TL',
	'TM',
	'TN',
	'TO',
	'TR',
	'TT',
	'TV',
	'TW',
	'TZ',
	'UA',
	'UG',
	'UM',
	'US',
	'UY',
	'UZ',
	'VA',
	'VC',
	'VE',
	'VG',
	'VI',
	'VN',
	'VU',
	'WF',
	'WS',
	'XK',
	'YE',
	'YT',
	'ZA',
	'ZM',
	'ZW',
] as const;

export const documentCategories = ['HISTORICAL_TRANSACTIONS', 'IDENTIFICATION', 'LICENSE'] as const;

export const entitySubtypes = ['INDIVIDUAL', 'ORGANIZATION'] as const;

export const entityTypesDefault = ['INTERMEDIARY', 'PIU', 'SUB_PIU'] as const;

export const entityTypesExt = ['BENEFICIARY', 'SUPPLIER'] as const;

export const entityTypesReadOnly = ['AUDITOR', 'BORROWER', 'DONOR', 'TAX_AUTHORITY'] as const;

export const entityTypes = [
	...entityTypesExt,
	...entityTypesReadOnly,
	...entityTypesDefault,
] as const;

export const errorIds = [
	'ACCOUNT_BALANCES_NON_EXISTENT',
	'ACCOUNT_DUPLICATE',
	'DESIGNATED_ACCOUNT_HAS_TRANSACTIONS',
	'ACCOUNT_ID_NON_EXISTENT',
	'ACCOUNT_INVALID_ENTITY_TRANSACTIONS',
	'ACCOUNT_INVALID_RELATIONSHIP',
	'ACCOUNT_INVALID_TYPE',
	'ACCOUNT_NON_EXISTENT',
	'ACCOUNT_OWNER_ASSOCIATE',
	'ACCOUNT_OWNER_NON_EXISTENT',
	'ACCOUNT_PROJECT_NON_EXISTENT',
	'ACCOUNT_UNAUTHORIZED_GET',
	'ACCOUNT_UNAUTHORIZED_PATCH',
	'ACCOUNT_UNAUTHORIZED_POST',
	'ACT_UNAUTHORIZED_PATCH',
	'ACT_UNAUTHORIZED_POST',
	'ACTIVITY_INVALID_TYPE',
	'ACTIVITY_UNAUTHORIZED_GET',
	'B2B_USER_NOT_PERMITTED',
	'BENEFIT_NON_EXISTENT',
	'BENEFIT_UNAUTHORIZED_POST',
	'BLOCKCHAIN_TRANSACTION_FAILED',
	'BULK_UPLOAD_FIELD_EMPTY',
	'BULK_UPLOAD_INCOMPLETE',
	'CASH_IN_METHOD_DEFAULT_CANNOT_DELETE',
	'CASH_IN_METHOD_DEFAULT_CANNOT_UPDATE',
	'CASH_IN_METHOD_NOT_FOUND',
	'CASH_IN_METHOD_UNAUTHORIZED',
	'CATEGORY_ALLOCATION_CURRENCY_REQUIRED',
	'CATEGORY_ALLOCATION_EXCEEDS_LOAN_AMOUNT',
	'CATEGORY_ALLOCATION_INVALID_AMOUNT',
	'CATEGORY_ALLOCATION_LOAN_NOT_FOUND',
	'CATEGORY_ALLOCATION_WBG_LOAN_AMOUNT_NOT_FOUND',
	'CATEGORY_DEFAULT_NOT_EDITABLE',
	'CATEGORY_NON_EXISTENT',
	'CATEGORY_NOT_FOUND',
	'CATEGORY_UNAUTHORIZED_PATCH',
	'CATEGORY_UNAUTHORIZED_POST',
	'COMMENT_UNAUTHORIZED_POST',
	'COMPONENT_ALLOCATION_CURRENCY_REQUIRED',
	'COMPONENT_ALLOCATION_EXCEEDS_LOAN_AMOUNT',
	'COMPONENT_ALLOCATION_INVALID_AMOUNT',
	'COMPONENT_ALLOCATION_LOAN_NOT_FOUND',
	'COMPONENT_NON_EXISTENT',
	'COMPONENT_UNAUTHORIZED_PATCH',
	'COMPONENT_UNAUTHORIZED_POST',
	'CONTRACT_DUPLICATE',
	'CONTRACT_ENTITIES_NON_EXISTENT',
	'CONTRACT_ID_NON_EXISTENT',
	'CONTRACT_NON_EXISTENT',
	'CONTRACT_UNAUTHORIZED_GET',
	'CONTRACT_UNAUTHORIZED_POST',
	'CONTRACT_COMMENT_REQUIRED',
	'COUNTRY_CODE_DUPLICATE',
	'COUNTRY_CODE_INVALID',
	'COUNTRY_DUPLICATE',
	'CRM_CREATE_ANNOTATION_ERROR',
	'CRM_CREATE_CONTACT_ERROR',
	'CRM_CREATE_INCIDENT_ERROR',
	'CRM_GENERATE_TOKEN_ERROR',
	'CSV_EMPTY_OR_INVALID',
	'DOCUMENT_CONTRACT_NON_EXISTENT',
	'DOCUMENT_DELETE_FAILED',
	'DOCUMENT_FILE_NON_EXISTENT',
	'DOCUMENT_INSERT_FAIL',
	'DOCUMENT_INVALID_CONTENT_TYPE',
	'DOCUMENT_INVALID_MIME_TYPE',
	'DOCUMENT_TRANSACTION_NON_EXISTENT',
	'DOCUMENT_UNAUTHORIZED_GET',
	'DOCUMENT_UNAUTHORIZED_POST',
	'DOCUMENT_TYPE_DUPLICATE',
	'DOCUMENT_TYPE_NAME_NON_EXISTENT',
	'DOCUMENT_TYPE_NON_EXISTENT',
	'DOCUMENT_TYPE_UNAUTHORIZED_POST',
	'ENTITY_DUPLICATE',
	'ENTITY_DUPLICATE_ID_EXTERNAL',
	'ENTITY_INVALID_TYPE',
	'ENTITY_KYC_UNVERIFIED',
	'ENTITY_LOANS_IDENTICAL',
	'ENTITY_PARENT_NON_EXISTENT',
	'ENTITY_UNAUTHORIZED_GET',
	'ENTITY_UNAUTHORIZED_PATCH',
	'ENTITY_UNAUTHORIZED_POST',
	'ENTITY_WALLET_NON_EXISTENT',
	'ENTITY_WALLET_RELATION_NON_EXISTENT',
	'EXPENSE_TYPE_DUPLICATE',
	'EXPENSE_TYPE_NAME_NON_EXISTENT',
	'EXPENSE_TYPE_NON_EXISTENT',
	'EXPENSE_TYPE_UNAUTHORIZED_POST',
	'EXPORT_NO_DATA',
	'FILE_INVALID_FORMAT',
	'FINANCING_SOURCE_NOT_SELECTED',
	'FORM_FIELD_CHECKBOX_INVALID',
	'FORM_FIELD_DATE_INVALID',
	'FORM_FIELD_LABEL_DUPLICATE',
	'FORM_FIELD_NUMBER_INVALID',
	'FORM_FIELD_SELECT_INVALID',
	'GRAPH_UNAUTHORIZED',
	'GRAPH_USER_NOT_FOUND',
	'ID_NON_EXISTENT',
	'IFR_INVALID_STATUS',
	'IFR_PLAN_CASH_IN_EXCEEDS_LOAN_AMOUNT',
	'IFR_PLAN_CASH_OUT_CATEGORY_MONTH_EXCEEDS_CASH_IN',
	'IFR_PLAN_CASH_OUT_COMPONENT_MONTH_EXCEEDS_CASH_IN',
	'IFR_PLAN_CATEGORY_ALLOCATION_EXCEEDED',
	'IFR_PLAN_COMPONENT_ALLOCATION_EXCEEDED',
	'IFR_PLAN_DUPLICATE',
	'IFR_PLAN_FISCAL_YEAR_DUPLICATE',
	'IFR_PLAN_FISCAL_YEAR_END_NON_EXISTENT',
	'IFR_PLAN_FISCAL_YEAR_START_NON_EXISTENT',
	'IFR_PLAN_INSERT_FAIL',
	'IFR_PLAN_NAME_NON_EXISTENT',
	'IFR_PLAN_VERSION_NOT_FINALIZED',
	'IFR_PLAN_NOT_FOUND',
	'IFR_PLAN_PROJECT_NON_EXISTENT',
	'IFR_PLAN_UNAUTHORIZED_GET',
	'IFR_PLAN_UNAUTHORIZED_PATCH',
	'IFR_PLAN_UNAUTHORIZED_POST',
	'IFR_PLAN_VERSION_DATA_IMMUTABLE',
	'IFR_PLAN_VERSION_DATA_INVALID_FOREIGN_KEY',
	'IFR_PLAN_VERSION_DATA_INVALID_MONTH',
	'IFR_PLAN_VERSION_DATA_INVALID_SINGLE_REFERENCE',
	'IFR_PLAN_VERSION_DATA_LOAN_NON_EXISTENT',
	'IFR_PLAN_VERSION_DATA_DUPLICATE',
	'IFR_PLAN_VERSION_DRAFT_EXISTS',
	'IFR_PLAN_VERSION_INSERT_FAIL',
	'IFR_PLAN_VERSION_INVALID_TRANSITION',
	'IFR_PLAN_VERSION_NOT_FOUND',
	'IFR_PLAN_VERSION_PLAN_NON_EXISTENT',
	'IFR_PLAN_VERSION_UNAUTHORIZED_GET',
	'IFR_PLAN_VERSION_UNAUTHORIZED_PATCH',
	'IFR_PLAN_VERSION_UNAUTHORIZED_POST',
	'IFR_UNAUTHORIZED_PATCH',
	'IFR_UNAUTHORIZED_POST',
	'INVALID_COLUMN',
	'LOAN_CURRENCY_NOT_FOUND',
	'LOAN_DISBURSED_GREATER_THAN_AMOUNT',
	'LOAN_DUPLICATE',
	'LOAN_ENTITY_DUPLICATE',
	'LOAN_INVALID_STATUS',
	'LOAN_NON_EXISTENT',
	'LOAN_UNAUTHORIZED_GET',
	'LOAN_UNAUTHORIZED_PATCH',
	'LOAN_UNAUTHORIZED_POST',
	'ME_UNAUTHORIZED_GET',
	'METHOD_NOT_ALLOWED',
	'NON_EXISTENT_CURRENCY',
	'PDF_FAILED',
	'PLAN_UNAUTHORIZED_POST',
	'PROJECT_ALREADY_ONBOARDED',
	'PRACTICE_DUPLICATE',
	'PROGRAM_UNAUTHORIZED_PATCH',
	'PROGRAM_UNAUTHORIZED_POST',
	'PROJECT_DUPLICATE',
	'PROJECT_ENTITY_NON_EXISTENT',
	'PROJECT_LOAN_DUPLICATE',
	'PROJECT_LOAN_NON_EXISTENT',
	'PROJECT_NON_EXISTENT',
	'PROJECT_REPORTING_CURRENCY_NOT_FOUND',
	'PROJECT_UNAUTHORIZED_GET',
	'PROJECT_UNAUTHORIZED_POST',
	'QUEUE_FAILURE',
	'REGION_DUPLICATE',
	'RECONCILIATION_ITEM_DEFAULT_CANNOT_EDIT',
	'RECONCILIATION_ITEM_UNAUTHORIZED_POST',
	'RECONCILIATION_ITEM_UNAUTHORIZED_PATCH',
	'REPORT_INVALID_TYPE',
	'REPORT_END_DATE_BEFORE_START_DATE',
	'TAG_NON_EXISTENT',
	'TAG_TRANSACTIONS_EXIST',
	'TAG_UNAUTHORIZED_DELETE',
	'TAG_UNAUTHORIZED_PATCH',
	'TAG_UNAUTHORIZED_POST',
	'TRANSACTION_ACCOUNTS_SAME',
	'TRANSACTION_AMOUNT_NON_EXISTENT',
	'TRANSACTION_DOCUMENTS_NON_EXISTENT',
	'TRANSACTION_ENTITY_NOT_FOUND',
	'TRANSACTION_EXCEEDS_CONTRACT',
	'TRANSACTION_EXCEEDS_LOAN_AMOUNT',
	'TRANSACTION_ID_NON_EXISTENT',
	'TRANSACTION_INSUFFICIENT_FUNDS',
	'TRANSACTION_INVALID_TYPE',
	'TRANSACTION_RECEIVED_AMOUNT_NON_EXISTENT',
	'TRANSACTION_REIMBURSED_EXCEEDS_REIMBURSEMENT',
	'TRANSACTION_UNAUTHORIZED_GET',
	'TRANSACTION_UNAUTHORIZED_PATCH',
	'TRANSACTION_UNAUTHORIZED_POST',
	'TRANSACTION_PATCH_INCOMPLETE',
	'UNKNOWN',
	'USER_DUPLICATE',
	'USER_EMAIL_NON_EXISTENT',
	'USER_FIRST_NAME_NON_EXISTENT',
	'USER_GROUP_INVALID',
	'USER_INVALID_ROLE',
	'USER_LAST_NAME_NON_EXISTENT',
	'USER_PERMISSION_NON_EXISTENT',
	'USER_PHONE_OR_EMAIL_EMPTY',
	'USER_UNAUTHORIZED_GET',
	'USER_UNAUTHORIZED_PATCH',
	'USER_UNAUTHORIZED_POST',
	'WALLET_CREATION',
	'WALLET_INACTIVE',
	'WALLET_UPDATE',
	'WITHDRAWAL_APPLICATION_ID_DUPLICATE',
] as const;

export const expenseTypeStatuses = ['ACTIVE', 'DEACTIVATED'] as const;

export const ifrStatuses = ['DELETED', 'DRAFT', 'FINALIZED', 'TRIAL'] as const;

export const ilapStatuses = [
	'COMPLETED',
	'ERROR',
	'FAILED',
	'PENDING',
	'RETRY',
	'STARTED',
] as const;

/**
 * ILAP Exceptions indicates issues with the data in the ILAP message, we cannot retry these
 */
export const ilapExceptionsCategories = [
	'ILAP_BAD_MESSAGE',
	'ILAP_BLOCKCHAIN',
	'ILAP_DB',
	'ILAP_INVALID_AMOUNT',
	'ILAP_CURRENCY_MISMATCH',
	'ILAP_NO_WBG_WALLET_FOUND',
] as const;

/**
 * Remaining ILAP categories can be retired by modifying the data within FundsChain
 */
export const ilapRetryableCategories = [
	'ILAP_NO_BANK_FOUND',
	'ILAP_NO_DA_FOUND',
	'ILAP_NO_PROJECT_FOUND',
	'ILAP_NO_SUPPLIER_FOUND',
] as const;

/**
 * All possible ILAP job categories
 */
export const ilapCategories = [
	...ilapExceptionsCategories,
	...ilapRetryableCategories,
	'ILAP_FINE',
] as const;

export const ilapMessageTypes = ['DA', 'Direct', 'Reimb'] as const;

export const exportResources = [
	'BENEFICIARY',
	'CASH_BENEFIT',
	'CONTRACT',
	'NON_CASH_BENEFIT',
	'OPEX',
	'PAYMENT',
	'SUPPLIER',
	'TRANSFER',
] as const;

export const articleCategories = [
	'ACCOUNTS',
	'ENTITIES',
	'PROJECTS',
	'REPORTS',
	'SETTINGS',
	'TRANSACTIONS',
] as const;

export const featureFlags = [
	'ACTIVITIES',
	'CRM',
	'DIRECT',
	'FINANCIAL_TRACEABILITY',
	'IFRS',
	'LEARNING_HUB',
	'LOCAL_CURRENCY',
	'REIMBURSEMENT',
	'UTILIZATION',
] as const;

export const filterTypes = [
	'ACCOUNT',
	'AUTOCOMPLETE',
	'CATEGORY',
	'COMPONENT',
	'COUNTRY',
	'CURRENCY',
	'DATE',
	'EXPENSE_TYPE',
	'INPUT',
	'SELECT',
	'TAGS',
	'WITHDRAWAL_APPLICATION',
] as const;

export const financiersWbg = ['COFN', 'IBRD', 'IDA', 'TF'] as const;
export const financiersExt = ['GOV', 'OTH'] as const;
export const financiers = [...financiersWbg, ...financiersExt] as const;

export const flagCodes = [...countryCodes, 'EU'] as const;

export const formFieldTypes = [
	'CHECKBOX',
	'DATE',
	'EMAIL',
	'NUMBER',
	'SELECT',
	'TEXT',
	'TIME',
	'URL',
] as const;

export const formNames = [
	'BENEFICIARY_INDIVIDUAL',
	'BENEFICIARY_ORGANIZATION',
	'SUPPLIER',
] as const;

export const frames = [
	'BENEFICIARIES',
	'BENEFICIARY',
	'ENTITY',
	'PROJECT',
	'SUPPLIER',
	'SUPPLIERS',
] as const;

export const ifrPlanVersionStatuses = [
	'APPROVED',
	'DRAFT',
	'FINALIZED',
	'REJECTED',
	'REVISION',
] as const;

export const ifrMonthColumnNames = [
	'month1',
	'month2',
	'month3',
	'month4',
	'month5',
	'month6',
	'month7',
	'month8',
	'month9',
	'month10',
	'month11',
	'month12',
] as const;

export const loadingStatuses = [
	'CLOSING',
	'DEFAULT',
	'DISABLED',
	'ERROR',
	'LOADING',
	'SUCCESS',
] as const;

export const loanConversionTypes = ['AMOUNT', 'CANCELLED', 'DISBURSED'] as const;

export const loanStatuses = ['DISABLED', 'ENABLED'] as const;

export const notificationTypes = [
	// Entities
	'AUDITOR_CREATED',
	'BENEFICIARY_CREATED',
	'BORROWER_CREATED',
	'DONOR_CREATED',
	'ENTITY_CREATED',
	'INTERMEDIARY_CREATED',
	'PIU_CREATED',
	'SUB_PIU_CREATED',
	'SUPPLIER_CREATED',
	'TAX_AUTHORITY_CREATED',

	// Transactions
	'CASH_BENEFIT_CONFIRMED',
	'CASH_BENEFIT_CREATED',
	'NON_CASH_BENEFIT_CREATED',
	'OPEX_CREATED',
	'PAYMENT_CONFIRMED',
	'PAYMENT_CREATED',
	'REPLENISHMENT_CREATED',
	'TRANSFER_CREATED',

	// Documents
	'DOCUMENT_CREATED',
	'DOCUMENT_UPDATED',

	// Accounts
	'ACCOUNT_CREATED',

	// Acts
	'ACT_CREATED',

	// Contracts
	'CONTRACT_CREATED',
	'CONTRACT_UPDATED',

	// Settings
	'PROGRAM_CREATED',
	'PROGRAM_UPDATED',
	'EXPENSE_TYPE_CREATED',
	'EXPENSE_TYPE_UPDATED',
	'COMPONENT_CREATED',
	'COMPONENT_UPDATED',
	'CATEGORY_CREATED',
	'CATEGORY_UPDATED',
	'DOCUMENT_TYPE_CREATED',
	'DOCUMENT_TYPE_UPDATED',
	'BENEFIT_CREATED',
	'BENEFIT_UPDATED',
	'TAG_CREATED',
	'TAG_UPDATED',
] as const;

export const orders = ['ASC', 'DESC'] as const;

export const paymentStatuses = ['DONE', 'FAILED', 'STARTED'] as const;

export const permissionOperations = [
	'APPROVE',
	'CREATE',
	'DELETE',
	'READ',
	'READ_PII',
	'UPDATE',
] as const;

export const permissionResources = [
	'ACCOUNT',
	'ACT',
	'BENEFICIARY',
	'BENEFIT',
	'CASH_BENEFIT',
	'CASH_IN_METHOD',
	'CATEGORY',
	'COMMENT',
	'COMPONENT',
	'CONTRACT',
	'DOCUMENT',
	'ENTITY',
	'EXPENSE_TYPE',
	'FORM',
	'LOAN',
	'NON_CASH_BENEFIT',
	'OPEX',
	'PAYMENT',
	'PROGRAM',
	'RECONCILIATION_ITEM',
	'REIMBURSEMENT',
	'REPLENISHMENT',
	'SUPPLIER',
	'TAG',
	'TRANSFER',
	'USER',
	'WITHDRAWAL_APPLICATION',
] as const;

export const projectCurrencyTypes = ['REPORTING', 'LOCAL', 'OTHER'] as const;

export const projectStatuses = ['ENABLED', 'PENDING'] as const;

export const reportTypes = [
	'BENEFICIARIES',
	'FUND_ALLOCATION',
	'FUND_FLOW',
	'IFR',
	'SOE',
	'SUPPLIERS',
] as const;

export const severities = ['default', 'error', 'info', 'success', 'warning'] as const;

export const tourNames = ['IFR', 'IFR_REPORTS_TAB'] as const;

export const tourStepTypes = ['DIALOG', 'POPOVER'] as const;

export const traceabilityTypes = ['FINANCIAL', 'TRANSACTIONS'] as const;

export const transactionStatuses = [
	'COMPLETED',
	'FAILED',
	'IN_PROGRESS',
	'PENDING',
	'REVERTED',
] as const;

export const transactionTypes = [
	'ADVANCE',
	'CASH_BENEFIT',
	'DIRECT',
	'INITIAL',
	'NON_CASH_BENEFIT',
	'OPEX',
	'PAYMENT',
	'REIMBURSEMENT',
	'REPLENISHMENT',
	'SPECIAL',
	'TRANSFER',
] as const;

export const transactionTypesIlap = ['ADVANCE', 'DIRECT', 'REIMBURSEMENT', 'SPECIAL'] as const;

export const userRoles = ['FNFA', 'GENERAL', 'LIAISON', 'STAFF', 'TTL', 'WFA'] as const;

export const userRolesWbg = ['FNFA', 'STAFF', 'TTL', 'WFA'] as const;

export const userStatuses = ['ACTIVE', 'CREATED', 'DEACTIVATED', 'INVITED'] as const;

export const utilizationStatuses = [
	'HIGH',
	'INDETERMINATE',
	'LOW',
	'MINIMAL',
	'MODERATE',
	'PENDING',
] as const;

export const walletStatuses = ['ACTIVE', 'INACTIVE'] as const;
